
import { AfterViewInit, Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { pcgSettings } from 'app/shared/generated/pcg-settings';
import { UserStateService } from 'app/state/user/user-state.service';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ConnectionState, SseNotificationService } from '../sse-notification/sse-notification.service';
import { InstallTimerComponent } from './install-timer/install-timer.component';
import { PushNotificationService } from './push-notification.service';

@Component({
    selector: 'pcg-push-notification',
    templateUrl: './push-notification.component.html',
    styleUrls: ['./push-notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    InstallTimerComponent,
    ButtonModule,
    TooltipModule
]
})
export class PushNotificationComponent implements AfterViewInit {
    isLocalHost = pcgSettings.mode === 'Development';
    sseService = inject(SseNotificationService);
    userState = inject(UserStateService);
    isLoggedOn = computed(() => this.userState.user() != null);
    sseNotificationHidden = signal(false);
    sseDisconnected = computed(() => this.isLoggedOn() 
        && this.sseService.sseInitialized()
        && this.sseService.connectionState() !== ConnectionState.CONNECTED
    );

    sseFailed = computed(() => 
        this.sseService?.sseOptions()?.isDisposed === true || this.sseService.connectionState() === ConnectionState.FAILED
    );

    sseIsConnecting = computed(() => this.sseService.connectionState() === ConnectionState.CONNECTING 
        || this.sseService.connectionState() === ConnectionState.RECONNECTING
    );

    scheduledInstall = computed(() =>  this.sseService.scheduledInstall());

    navSpacerVisible = signal<boolean>(false);

    /** Set the view loaded signal to true after the view has been initialized */
    ngAfterViewInit(): void {
        this.sseNotificationHidden.update(hidden => localStorage.getItem('HIDE-SSE-DISCONNECTED') === 'true');
        this.navSpacerVisible.set(PushNotificationService.checkForNavSpace());
        this.reconnectSSE();  
    }

    /** Reload the page */
    hardReload() {
        globalThis.location.reload();
        return false;
    }

    /** Reconnect to Server Sent Event if disconnected */
    reconnectSSE() {
        this.sseService.getSseOptions();

        if (this.sseDisconnected()) {
            return this.sseService.reconnect();
        }
    }

    toggleHidden() {
        this.sseNotificationHidden.update(hidden => !hidden);
        localStorage.setItem('HIDE-SSE-DISCONNECTED', this.sseNotificationHidden().toString());
    }
}
